import { render, staticRenderFns } from "./v3_mobile.vue?vue&type=template&id=284b6194&"
import script from "./v3_mobile.vue?vue&type=script&lang=js&"
export * from "./v3_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports